import { useEffect, useState } from 'react'
import { Navigate, useNavigate } from 'react-router-dom'
import { api } from '../api'
import { Loading } from '../Loading'

export function LoginPage() {
  const nav = useNavigate()
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [authed, setAuthed] = useState<boolean | null>(null)

  useEffect(() => {
    void api.me().then((r) => setAuthed(!!r.user))
  }, [])

  if (authed === true) return <Navigate to="/admin" replace />
  if (authed === null) return <Loading />

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault()
    setError(null)
    try {
      await api.login(username, password)
      nav('/admin')
    } catch (err) {
      setError(err instanceof Error ? err.message : '登入失敗')
    }
  }

  return (
    <div className="card stack" style={{ maxWidth: 480 }}>
      <h1>後台登入</h1>
      <form className="stack" onSubmit={onSubmit}>
        <label className="stack">
          <span className="muted">帳號</span>
          <input className="input" value={username} onChange={(e) => setUsername(e.target.value)} autoComplete="username" />
        </label>
        <label className="stack">
          <span className="muted">密碼</span>
          <input
            className="input"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
          />
        </label>
        {error ? <div style={{ color: '#fecaca' }}>{error}</div> : null}
        <button className="btn primary" type="submit">
          登入
        </button>
      </form>
    </div>
  )
}
